export default __webpack_public_path__ + "static/5-288eed1fb0b448543a347fc3c0158252.jpeg";